














































import { Component, Mixins, Vue } from 'vue-property-decorator';
import MixinResults from '@/plugins/podolib/services/helper/mixins/results';

@Component({
  components: {
    ChartRawWalkingDetailed: () => import('@/components/charts/walking/ChartRawWalkingDetailed.vue'),
    PatientAcquisitionComments: () => import('@/components/patients/PatientAcquisitionComments.vue'),
    ElementBlocGeneralInterpretation: () => import('@/components/elements/ElementBlocGeneralInterpretation.vue'),
  },
})
export default class PatientResultsWalkingDetailed extends Mixins(MixinResults) {}
